import { Box, Grid, Typography } from "@mui/material";
import { allColors } from "../../constants";
import GlobalButton from "../../components/globalButton";
import { images } from "../../assets";

const STATS_DATA = [
    { value: "5+", label: "years of expertise" },
    { value: "1200+", label: "projects completed" },
    { value: "650+", label: "happy clients" },
    { value: "09", label: "services" },
];

const DevelopmentServiceBanner = () => {
    return (
        <Box
            borderRadius={3}
            pb={4}
            sx={{
                background: "linear-gradient(90deg, #1F4CFE 0%, #FFFFFF 100%)",
            }}
        >
            <Grid container spacing={2} >
                <Grid
                    item
                    xs={12} md={6}
                >
                    <Box
                        p={{ xs: 2, sm: 4, md: 6, lg: 8 }}
                    >

                        <Typography
                            fontSize={{ xs: "30px", md: "40px" }}
                            fontWeight={600}
                            fontFamily="Raleway"
                            color={allColors.white}
                            lineHeight={"normal"}
                            mb={2}
                        >
                            Software Solutions to Digitise Your Ideas
                        </Typography>
                        <Typography
                            fontSize={{ xs: "15px", md: "16px" }}
                            fontWeight={400}
                            fontFamily="Raleway"
                            color={allColors.white}
                        >
                            As a top-tier team of professionals, we craft memorable & impactful
                            digital experiences. We help businesses grow by solving complex
                            problems with excellence-driven intelligent solutions.
                        </Typography>

                        <GlobalButton
                            variant={"contained"}
                            title="Lets Discuss"
                            handleClickBtn={() => {
                                document
                                    .getElementById("development-service-contact-us")
                                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
                            }}
                            style={{
                                marginTop: "20px",
                                color: allColors.black,
                                borderColor: allColors.white,
                                backgroundColor: allColors.white,
                                borderRadius: "2px",
                                height: "50px",
                                width: { xs: "100%", md: "150px" },
                            }}
                            hoverProperties={{
                                backgroundColor: allColors.white,
                                color: allColors.black,
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Box
                        component={"img"}
                        src={images.developmentServiceBannerImg}
                        alt="Development Service Banner"
                        width={"30%"}
                        height={"auto"}
                    />
                </Grid>
            </Grid>
            <Box
                bgcolor={"#101114"}
                borderBottomLeftRadius={"12px"}
                borderBottomRightRadius={"12px"}
                px={{ xs: 1, sm: 2, md: 3 }}
                py={{ xs: 1.5, md: 2 }}
                mt={{ xs: 1 }}

            >
                <Grid container>
                    {STATS_DATA.map((item, index) => (
                        <Grid
                            item
                            xs={6}
                            md={3}
                            key={item.label}
                            sx={{
                                textAlign: "center",
                                borderRight: {
                                    xs: index % 2 === 0 ? "1px solid rgba(255,255,255,0.08)" : "none",
                                    md: index !== STATS_DATA.length - 1 ? "1px solid rgba(255,255,255,0.08)" : "none",
                                },
                                borderBottom: {
                                    xs: index < 2 ? "1px solid rgba(255,255,255,0.08)" : "none",
                                    md: "none",
                                },
                                py: { xs: 1.25, md: 0.5 },
                            }}
                        >
                            <Typography
                                color={allColors.white}
                                fontWeight={700}
                                fontSize={{ xs: "24px", md: "34px" }}
                                lineHeight={1}
                                mb={0.5}
                            >
                                {item.value}
                            </Typography>
                            <Typography
                                color="rgba(255,255,255,0.8)"
                                fontSize={{ xs: "11px", md: "12px" }}
                                textTransform="lowercase"
                            >
                                {item.label}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default DevelopmentServiceBanner;
